import { put, call, takeLatest } from 'redux-saga/effects';
import { Types, Creators } from './duck.js';
import { toast } from 'react-toastify';
import Api from './api.js';
import { Creators as GlobalCreators } from '../globals/globals-duck.js';
import toastApiError from 'utils/api-error.js';

// Ajuste conforme o nome do slice no seu rootReducer
export const getState = (state) => state.TradeInSimulations;

/** LISTAR (GET /trade-in-simulations) - Painel */
export function* fetchAsync() {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    // Se houver filtros no futuro, pode usar: const { filters } = yield select(getState);
    const list = yield call(Api.getAll);
    yield put(Creators.tradeInSimulationsFetchSuccess(list));
  } catch (error) {
    toastApiError(error);
    yield put(Creators.tradeInSimulationsFetchFailure(error));
  } finally {
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

/** CRIAR (POST /trade-in-simulations) - Público */
export function* createAsync({ payload }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    yield call(Api.create, payload);
    yield put(Creators.tradeInSimulationsCreateSuccess());
    toast.success('Simulação enviada com sucesso!');
  } catch (error) {
    toastApiError(error);
    yield put(Creators.tradeInSimulationsCreateFailure(error));
  } finally {
    // Não chamamos fetchAsync() aqui para evitar 401 no formulário público
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

/** ATUALIZAR STATUS (PATCH /trade-in-simulations/{id}/status) - Painel */
export function* updateStatusAsync({ id, status }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    yield call(Api.updateStatus, id, status);
    yield put(Creators.tradeInSimulationsUpdateStatusSuccess(id, status));
    toast.success('Status atualizado com sucesso!');
  } catch (error) {
    toastApiError(error);
    yield put(Creators.tradeInSimulationsUpdateStatusFailure(error));
  } finally {
    // Recarrega a lista para refletir ordenação por status/data
    yield fetchAsync();
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export default [
  // Painel (restrito)
  takeLatest(Types.TRADE_IN_SIMULATIONS_FETCH_ASYNC, fetchAsync),
  takeLatest(Types.TRADE_IN_SIMULATIONS_UPDATE_STATUS_ASYNC, updateStatusAsync),

  // Público
  takeLatest(Types.TRADE_IN_SIMULATIONS_CREATE_ASYNC, createAsync),
];
